import React, { useMemo } from 'react';
import { publicUrl } from '../utils/publicUrl';

function imageOnRight(float, imgFloat) {
  if (imgFloat === 'right') return true;
  if (imgFloat === 'left') return false;
  return float === 'right';
}

export default function Project({
  float,
  imgFloat,
  projectName,
  imgUrl,
  tech1,
  tech2,
  tech3,
  tech4,
  description,
  githublink,
  linkLabel,
}) {
  const tech = useMemo(
    () => [tech1, tech2, tech3, tech4].filter((t) => t && String(t).trim()),
    [tech1, tech2, tech3, tech4]
  );

  const imgRight = imageOnRight(float, imgFloat);

  return (
    <article
      className={`project-card${imgRight ? ' project-card--img-right' : ''}`}
      data-aos="fade-up"
      data-aos-once
    >
      <div className="project-card__inner">
        <div className="project-card__media">
          <img src={publicUrl(imgUrl)} alt="" loading="lazy" />
        </div>
        <div className="project-card__body">
          <h2 className="project-card__title">{projectName}</h2>
          {tech.length > 0 && (
            <ul className="project-card__tech" aria-label="Technologies">
              {tech.map((t) => (
                <li key={t}>{t.replace(/\/$/, '')}</li>
              ))}
            </ul>
          )}
          <p className="project-card__description">{description.trim()}</p>
          {githublink && (
            <a
              className="project-card__link"
              href={githublink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {linkLabel || 'View on GitHub'}
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
                <path
                  d="M7 17L17 7M17 7H7M17 7V17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          )}
        </div>
      </div>
    </article>
  );
}
